import React from 'react'

function NF (props) {
    return global.nameFn(props.children)
}


export default NF
